import React, { Component } from "react";
import { connect } from "react-redux";
import { loadQuote, loadCustomerGuid } from "../actions";

import "css/SplashScreen.css";
import Loading from "../components/Loading";


class LoadEnquiryData extends Component {
    getQueryVariable(key){
        const query = this.props.location.search.substring(1);
        const vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === key) {
                return decodeURIComponent(pair[1]);
            }
        }
        return null;
    }
    componentDidMount() {
        // simulate slow server
        setTimeout(() => {
            // load the customer stuff
            const params = window.location.search;
            console.log(params);
            if(params) {
                sessionStorage.setItem("params", params);
            }
            this.props.loadCustomerGuid(this.props.match.params.customerGuid, () => {
                if (!this.props.match.params.enquiryUid) {
                    const route = this.getQueryVariable("route");

                    switch (route) {
                        case "door":
                            this.props.history.push("/Item/Door");
                            break;
                        case "window":
                            this.props.history.push("/Item/Window");
                            break;
                        default:
                            this.props.history.push("/Item/Selector");
                            break;
                    }

                    return;
                }
                this.props.loadQuote(this.props.match.params.enquiryUid, () => {
                    this.props.history.push("/Summary");
                });
            });
        }, 1000);
    }
    render() {
        return (
            <div className="SplashScreen">
                <Loading />
            </div>
        );
    }
}

export default connect(null, { loadCustomerGuid, loadQuote })(LoadEnquiryData);



// WEBPACK FOOTER //
// ./src/containers/LoadEnquiryData.js